import config from '../../config/index';

class BrowserEnvironment {
  constructor () {
    console.log('BrowserEnvironment');
    this.initCallbacks = [];
    this.shareSuccessCallbacks = [];
  }
  getEnvInfo () {
    return Promise.resolve({ env: 'h5' });
  }
  subscribe ({ init, shareSuccess }) {
    this.initCallbacks.push(init);
    this.shareSuccessCallbacks.push(shareSuccess);
    this.getEnvInfo().then(({ env }) => {
      this.execute(this.initCallbacks, { env });
      this.initCallbacks = [];
    });
  }
  execute (callBacks, args) {
    if (Array.isArray(callBacks)) {
      callBacks.forEach((item) => {
        if (typeof item === 'function') {
          Promise.resolve().then(() => {
            item(args);
          });
        }
      });
    }
  }
  /**
   * 获取分享数据
   */
  getShareData () {
    return this.shareData || config.shareData;
  }
  /**
   * 设置分享数据
   * @param {*} opts
   */
  setShareData (opts) {
    let self = this;
    opts = opts || {};
    // 微信分享开始
    self.shareData = {
      title: opts.title || config.shareData.title,
      desc: opts.desc || config.shareData.desc,
      icon: opts.icon || config.shareData.icon,
      link: opts.link || config.shareData.link
    };
  }
  showShare () {
    console.log('showShare');
  }

  saveShareImage () {
    console.log('saveShareImage');
  }
  /**
   * 打开直播页面
   * @param {roomId, sourceId} roomId 房间id, sourceId 来源id
   */
  openLive ({ roomId, pvareaid = 2594195 }) {
    window.location = `${config.live}/live/${roomId}?pvareaid=${pvareaid}`;
  }
  /**
   * 打开新页面
   * @param {*} param0
   */
  openPage ({ url }) {
    window.location = url;
  }
  /**
   *
   */
  setIsIntercept () {
    console.log('setIsIntercept');
  }
  /**
   *
   */
  bindIntercept () {
    console.log('bindIntercept');
  }
  back () {
    window.history.go(-1);
  }
  login ({ backUrl }) {
    return new Promise(function (resolve, reject) {
      window.location = `https://account.m.autohome.com.cn?backurl=${encodeURIComponent(
        backUrl
      )}&fPosition=10011&sPosition=1001101&platform=2&popWindow=0`;
      let error = '页面跳转';
      reject(error);
    });
  }
  doShare () {
    console.log('doShare');
  }
}
export default BrowserEnvironment;
